import { ValidationErrorDetails } from '../validation-error-details';

export class ArrayContainsValidatorResult {
  public arrayContains: ValidationErrorDetails;
}
